import {Calendar, momentLocalizer} from "./calendar";
import moment from "moment";
import './/calendar/sass/styles.scss'
import 'moment/locale/ru';
import PropTypes from 'prop-types'
import React from "react";

function CalendarV2(props) {
    moment.locale("ru")
    const localizer = momentLocalizer(moment)

    return (
        <Calendar
            popup
            selectable={"ignoreEvents"}
            popupOffset={{x: 220, y: 0}}
            culture={"ru-RU"}
            localizer={localizer}
            onSelectSlot={(event) => props.onEmptyClick(event)}
            events={props.events}
            startAccessor="start"
            endAccessor="end"
            style={{height: props.height}}
            views={["month"]}
            onDoubleClickEvent={(event) => props.onEventClick(event)}
            onNavigate={date => props.onNavigate(date)}
            messages={{
                today: "Сегодня",
                previous: 'Назад',
                next: 'Вперёд',
                week: 'Неделя',
                month: "Месяц",
                day: "День"
            }}
        />
    );
}

CalendarV2.propTypes = {
    height: PropTypes.number,
    onEventClick: PropTypes.func,
    onNavigate: PropTypes.func,
    onEmptyClick: PropTypes.func,
    events: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        start: PropTypes.string,
        end: PropTypes.string,
        allDay: PropTypes.bool,
        resource: PropTypes.string,
        color: PropTypes.string,
    }))
}

function def() {
}

CalendarV2.defaultProps = {
    onEventClick: def,
    onNavigate: def,
    events: []
}
export default CalendarV2;
